import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
    const loadingService = inject(LoadingService);

    // Skip loading bar for background polling or specific silent requests if needed
    // For now, track everything
    loadingService.show();

    return next(req).pipe(
        finalize(() => loadingService.hide())
    );
};
